import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../../components/grid";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO, } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { Settings } from "feather-icons-react/build/IconComponents";
import { sharedNextPage } from "../../../utils/shared-functions";
// import ModalNuevaUnidad from "../../../components/nuevo-vehiculo";
// import { createVehicle, deshabilitarVehiculo, disableVehiculo, habilitarVehiculo, obtenerListaVehiculos, obtenerVehiculoPorPlaca } from "../../../api/api-vehiculo";
import Select from "react-select";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import { actualizarLimiteVehiculo, obtenerListaEmpresas, obtenerEquiposActivosPorEmpresa } from "../../../api/api-empresa";
import ModalLimiteVehiculo from "../../../components/modal-limite-vehiculo";
import moment from "moment";
// const idTipoUsuario = parseInt(localStorage.getItem("tipoUsuarioChecklist"));
let accesoBotonNuevo = '';


export default function ListarEmpresas() {
  const headers = [
    { key: "acciones", title: "ACCIONES" },
    { key: "id", title: "ID", visible: false, },
    { key: "codigo", title: "CODIGO", visible: true, filter: true, editLabel: true, },
    { key: "nombre", title: "NOMBRE", visible: true, filter: true, },
    { key: "telefonoEmpresa", title: "TELEFONO EMPRESA", visible: true, filter: true, editLabel: true, },
    { key: "emailEmpresa", title: "EMAIL EMPRESA", visible: true, filter: true, editLabel: true, },
    { key: "representante", title: "REPRESENTANTE", visible: true, filter: true, editLabel: true, },
    { key: "telefonoRepresentante", title: "TELEFONO REPRESENTANTE", visible: true, filter: true, editLabel: true, },
    { key: "emailRepresentante", title: "EMAIL REPRESENTANTE", visible: true, filter: true, editLabel: true, },
    { key: "timeZone", title: "TIME ZONE", visible: true, filter: true, editLabel: true, },
    { key: "fechaModificacion", title: "FECHA MODIFICACION", visible: true, filter: true },
    { key: "habilitado", title: "HABILITADO", visible: true, filter: true, editLabel: true, },

    { key: "equiposActivos", title: "EQUIPOS ACTIVOS", visible: true, filter: true },
    { key: "equiposDesinstalados", title: "EQUIPOS DESACTIVADOS", visible: true, filter: true },
    { key: "precioUnitarioEquipo", title: "P/U EQUIPO", visible: true, filter: true },
    { key: "totalCobro", title: "TOTAL COBRO", visible: true, filter: true, onClick: (data) => navigateToListaEmpresas(data) },
    { key: "moneda", title: "MONEDA", visible: true, filter: true },
  ];

  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [modalLimiteVehiculoVisible, setModalLimiteVehiculoVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      /*obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      let permiso = null;
      let lista = [];

      // setTieneAccesoAlModulo(true);
      lista = await obtenerListaEmpresas();
      agregarAccionesALista(lista, permiso);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const agregarDatosExtra = async (lista) => {
    try {
      // console.log('agregarDatosExtra');
      // let lista = [...listaElementos];
      // console.log('lista');
      // console.log(lista);
      for (let i = 0; i < lista.length; i++) {
        const element = lista[i];
        // console.log('element', element);
        const fechaInicio = moment().startOf("month").format("YYYY-MM-DD");
        const fechaFin = moment().endOf("month").format("YYYY-MM-DD");
        let objEnviar = {};
        objEnviar.id = element.id;
        objEnviar.fechaInicio = fechaInicio;
        objEnviar.fechaFin = fechaFin;
        const response = await obtenerEquiposActivosPorEmpresa(objEnviar);
        // console.log('response', response);
        // debugger;
        const equiposActivos = response.equiposActivos || 0;
        const equiposDesinstalados = response.equiposDesinstalados || 0;
        lista[i].equiposActivos = equiposActivos.toString();
        lista[i].equiposDesinstalados = equiposDesinstalados.toString();
        if ((equiposActivos > 0 || equiposDesinstalados > 0) && isNaN(element.precioUnitarioEquipo) === false) {
          const totalActivos = parseInt(equiposActivos) * element.precioUnitarioEquipo;
          const totalDesactivados = parseInt(equiposDesinstalados) * element.precioUnitarioEquipo;
          // console.log('totalCobro', totalCobro);
          const totalCobro = totalActivos + totalDesactivados;
          lista[i].totalCobro = totalCobro.toString();
        } else {
          lista[i].totalCobro = null;
        }
        // console.log('**************************');
      }
      // console.log('=====================');
      // console.log(lista);
      setListaElementos(lista);
    } catch (err) {
      console.log('agregarDatosExtra err');
      console.log(err);
    }
  };

  const agregarAccionesALista = (lista) => {
    try {
      // console.log('agregarAccionesALista');
      // console.log(lista);
      if (lista.length === 0) {
        setListaElementos(lista);
        return;
      }
      if (lista.length > 0) {
        const objModificar = {
          label: "Modificar",
          color: "green",
          onClick: (param) => editarElementoSelected(param),
        };
        const objDeshabilitar = {
          label: "Deshabilitar",
          color: "red",
          onClick: (param) => disableVehiculo(param),
        };
        const objHabilitar = {
          label: "Habilitar",
          color: "red",
          onClick: (param) => enableVehiculo(param),
        };
        // const objLimite = {
        //   label: "Limite",
        //   color: "blue",
        //   onClick: (param) => showModalLimite(param),
        // };
        // if (idTipoUsuario !== INT_TIPO_USUARIO_ADMINISTRADOR_WEB) {
        // if (permiso.nuevo === TRUE) {
        accesoBotonNuevo = '';
        // }
        // }
        for (let i = 0; i < lista.length; i++) {
          const element = lista[i];
          let acciones = [];
          acciones.push(objModificar);
          if (element.habilitado === 1) {
            acciones.push(objDeshabilitar);
          }
          if (element.habilitado === 0) {
            acciones.push(objHabilitar);
          }
          // acciones.push(objLimite);
          lista[i].acciones = acciones;
        }
        // setListaElementos(lista);
      }
      agregarDatosExtra(lista);
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  };

  const editarElementoSelected = (data) => {
    try {
      // console.log("editarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = "MODIFICAR EMPRESA";
      obj.params = data;
      obj.idVehiculo = data.id;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("modificar-empresa", obj, history);
    } catch (err) {
      console.log("editarElementoSelected err");
      console.log(err);
    }
  };

  const disableVehiculo = async (data) => {
    try {
      // console.log("disableVehiculo");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("disableVehiculo err");
      console.log(err);
    }
  };

  const enableVehiculo = async (data) => {
    try {
      // console.log("habilitarVehiculo");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("enableVehiculo err");
      console.log(err);
    }
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleModalDeshabilitarModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      /*const response = await deshabilitarVehiculo(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se deshabilito correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo deshabilitar');
      }*/
    }
  };

  const handleModalHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      /*const response = await habilitarVehiculo(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se habilito correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo habilitar');
      }*/
    }
  };

  const handleNuevoClick = () => {
    try {
      // console.log('handleNuevoClick');
      let obj = {};
      let data = {};
      data.id = 0;
      data.codigo = "";
      data.nombre = "";
      data.telefonoEmpresa = "";
      data.emailEmpresa = "";
      data.representante = "";
      data.telefonoRepresentante = "";
      data.emailRepresentante = "";
      data.timeZone = "";
      data.usuario = "";
      data.password = "";
      data.confirmarPassword = "";
      data.limiteVehiculo = "";
      obj.titulo = "NUEVA EMPRESA";
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("empresa", obj, history);
    } catch (err) {
      console.log('handleNuevoClick err');
      console.log(err);
    }
  };

  const handleModalAceptarLimiteVehiculo = async (data) => {
    setModalLimiteVehiculoVisible(false);
    // console.log('handleModalAceptarLimiteVehiculo');
    // console.log(data);
    // console.log('elementoSelected');
    // console.log(elementoSelected);
    if (elementoSelected === null || elementoSelected.id === 0) {
      alert('No se selecciono ningun vehiculo');
      return;
    }
    if (String(data.limiteVehiculo).trim().length === 0) {
      alert('Ingrese un limite');
      return;
    }
    let objEnviar = {};
    objEnviar.idEmpresa = elementoSelected.id;
    objEnviar.limiteVehiculo = data.limiteVehiculo;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await actualizarLimiteVehiculo(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert('Se actualizo correctamente');
        reset();
      }
      if (response.error === true) {
        alert('No se pudo actualizar');
      }
    }
  };

  const navigateToListaEmpresas = (data) => {
    try {
      console.log("navigateToListaEmpresas", data);
      if (data.totalCobro !== undefined && data.totalCobro !== null && String(data.totalCobro).trim().length > 0) {
        sharedNextPage("empresas-creadas", data, history);
      }
    } catch (err) {
      console.log('navigateToListaEmpresas err', err);
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="p-4">
          <div className="flex justify-between">
            <label
              style={{
                paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              GESTIONAR EMPRESAS
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => { handleNuevoClick(); }}
                style={{
                  display: accesoBotonNuevo,
                }}
              >
                NUEVO
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={(handleAtrasClick)}
              >
                ATRAS
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="">
              <label
                className="block text-[#0F3457] font-semibold mb-2"
                htmlFor="habilitado"
              >
                ESTADO
              </label>
              <Select
                options={SELECT_HABILITADO_DESHABILITADO}
                isSearchable={true} // Boolean props should not be strings
                isClearable={true}
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder="SELECCIONE HABILITADO"
              />
            </div>
            <div className="">
              <label className="block">&nbsp;</label>
              <button
                type="button"
                className={`bg-[#000D39] text-white font-semibold py-2 px-4 rounded hover:bg-[#0F3457] transition`}
                onClick={() => reset()}
              >
                BUSCAR
              </button>
            </div>
          </div>
          <Grid rows={listaElementos} headers={headers} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleModalDeshabilitarModal}
            message="¿Estás de deshabilitar Unidad?"
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleModalHabilitarModal}
            message="¿Estás de habilitar Unidad?"
          />
          <ModalLimiteVehiculo
            isOpen={modalLimiteVehiculoVisible}
            onCancel={() => { setModalLimiteVehiculoVisible(false); }}
            onConfirm={handleModalAceptarLimiteVehiculo}
            limiteActual={elementoSelected?.limite}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarArea render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
